import { z } from 'zod';

export const SlotQuerySchema = z.object({
  gymId: z.string().uuid(),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});

export const BlockSlotInputSchema = z.object({
  gymId: z.string().uuid(),
  startTime: z.string().datetime(),
  reason: z.string().min(1).max(240),
  effectiveMode: z.enum(['IMMEDIATE', 'NEXT_DAY']).default('IMMEDIATE'),
});

export const UnblockSlotInputSchema = z.object({
  gymId: z.string().uuid(),
  startTime: z.string().datetime(),
});

const LocalTimeSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);

export const CreateRecurringSlotBlockInputSchema = z
  .object({
    gymId: z.string().uuid(),
    daysOfWeek: z.array(z.number().int().min(0).max(6)).min(1).max(7),
    startTime: LocalTimeSchema,
    endTime: LocalTimeSchema,
    reason: z.string().trim().min(1).max(240),
    effectiveFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    effectiveUntil: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional(),
  })
  .refine((value) => value.endTime > value.startTime, {
    message: 'End time must be after start time',
    path: ['endTime'],
  })
  .refine((value) => !value.effectiveUntil || value.effectiveUntil >= value.effectiveFrom, {
    message: 'End date must be on or after start date',
    path: ['effectiveUntil'],
  });

export type SlotQuery = z.infer<typeof SlotQuerySchema>;
export type BlockSlotInput = z.infer<typeof BlockSlotInputSchema>;
export type UnblockSlotInput = z.infer<typeof UnblockSlotInputSchema>;
export type CreateRecurringSlotBlockInput = z.infer<typeof CreateRecurringSlotBlockInputSchema>;
